<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<style>

html,body{
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  width:100%;
  height:100%
}
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
body{
   margin: 0;
  font-family: "PingFangSC-Regular", "Microsoft YaHei", "Hiragino Sans GB",
    tahoma, Arial, "\5B8B\4F53", "STHeiti", "WenQuanYi Micro Hei", SimSun,
    sans-serif;
  font-size: 14px;
  line-height: 1;
  color: #333;
  background-color: #fff;
  word-wrap: break-word;
}

#app{
  height: 100%;
  width: 100%;
}

</style>
<script>
export default {
  name: '',
  components: {},
  provide() {
    return{
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  mounted() {
    //this.isLogin();
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
